export default __webpack_public_path__ + "static/media/avatar.afa62217.svg";